import Http from '@/common/http'
export default class Setting {
  static doTagSubmit (param = {}) {
    return Http.post('/setting/tag/doSubmit', param)
  }
  static tagIndex (param = {}) {
    return Http.post('/setting/tag/index', param)
  }
  static getTagTypeList (param = {}) {
    return Http.post('/setting/tag/getTagTypeList', param)
  }
  static doTagTypeSubmit (param = {}) {
    return Http.post('/setting/tag/doTypeSubmit', param)
  }
  static TagtypeIndex (param = {}) {
    return Http.post('/setting/tag/type', param)
  }
  static group (param = {}) {
    return Http.post('/setting/tag/group', param)
  }
  static doGroupSubmit (param = {}) {
    return Http.post('/setting/tag/doGroupSubmit', param)
  }
  static getUtmList (param = {}) {
    return Http.get('/setting/utm/getUtmList', param)
  }
  static saveJdUtm (param = {}) {
    return Http.post('/setting/utm/saveJdUtm', param)
  }
  static delUtm (param = {}) {
    return Http.post('/setting/utm/delUtm', param)
  }
  static getUtmGroupList (param = {}) {
    return Http.get('/setting/utm/getUtmGroupList', param)
  }
  static delUtmGroup (param = {}) {
    return Http.post('/setting/utm/delUtmGroup', param)
  }
  static saveJdUtmGroup (param = {}) {
    return Http.post('/setting/utm/saveJdUtmGroup', param)
  }
  static updateUtmGroup (param = {}) {
    return Http.post('/setting/utm/updateUtmGroup', param)
  }
}
